const PIXEL_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID;
const TEST_EVENT_CODE = process.env.REACT_APP_TIKTOK_TEST_EVENT_CODE;
const PRIVATE_PREFIXES = ["/crm", "/admin", "/mi-reserva"];
const SCHEDULE_SENT_KEY = "tt_schedule_sent";

let loaded = false;

export function isPrivatePath(pathname) {
  return PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Official TikTok snippet, without the automatic ttq.page() (handled per navigation)
function installSnippet(w, d, t) {
  w.TiktokAnalyticsObject = t;
  const ttq = (w[t] = w[t] || []);
  ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
  ttq.setAndDefer = function (obj, method) {
    obj[method] = function () {
      obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };
  for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
  ttq.instance = function (id) {
    const inst = ttq._i[id] || [];
    for (let n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(inst, ttq.methods[n]);
    return inst;
  };
  ttq.load = function (id, opts) {
    const src = "https://analytics.tiktok.com/i18n/pixel/events.js";
    ttq._i = ttq._i || {};
    ttq._i[id] = [];
    ttq._i[id]._u = src;
    ttq._t = ttq._t || {};
    ttq._t[id] = +new Date();
    ttq._o = ttq._o || {};
    ttq._o[id] = opts || {};
    const s = d.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = `${src}?sdkid=${id}&lib=${t}`;
    const first = d.getElementsByTagName("script")[0];
    first.parentNode.insertBefore(s, first);
  };
}

export function loadPixel() {
  if (loaded || !PIXEL_ID) return;
  loaded = true;
  installSnippet(window, document, "ttq");
  window.ttq.load(PIXEL_ID);
  window.ttq.grantConsent();
}

export function grantPixelConsent() {
  if (loaded) window.ttq.grantConsent();
}

export function revokePixelConsent() {
  if (loaded) window.ttq.revokeConsent();
}

export function trackPageView() {
  if (loaded) window.ttq.page();
}

// Generic funnel event (no PII). Standard TikTok names where they exist, custom otherwise.
export function trackEvent(name, props = {}) {
  if (!loaded) return;
  const options = TEST_EVENT_CODE ? { test_event_code: TEST_EVENT_CODE } : undefined;
  window.ttq.track(name, props, options);
}

function hashId(str) {
  let h = 5381;
  for (let i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  return `cal_${(h >>> 0).toString(36)}`;
}

// Fires TikTok standard event "Schedule" once per Calendly invitee URI (no PII)
export function trackSchedule(inviteeUri) {
  if (!loaded || !inviteeUri) return false;
  const eventId = hashId(inviteeUri);
  let sent = [];
  try {
    sent = JSON.parse(localStorage.getItem(SCHEDULE_SENT_KEY) || "[]");
  } catch {
    sent = [];
  }
  if (sent.includes(eventId)) return false;
  const options = { event_id: eventId };
  if (TEST_EVENT_CODE) options.test_event_code = TEST_EVENT_CODE;
  window.ttq.track(
    "Schedule",
    { content_type: "product", content_id: "calendly-30min", content_name: "Reunion GTX 30 min" },
    options
  );
  localStorage.setItem(SCHEDULE_SENT_KEY, JSON.stringify([...sent, eventId].slice(-20)));
  return true;
}
